import { MoreVert } from '@mui/icons-material'
import { IconButton, Menu, MenuItem } from '@mui/material'
import * as React from 'react'

export default function GridActions(props: any) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const gridApiRef = props.gridApiRef
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (exportType: string) => {
    switch (exportType) {
      case 'CSV':
        gridApiRef.current!.api.exportDataAsCsv({
          useValueFormatterForExport: false,
          processCellCallback: (params: any) => {
            const field = params?.column?.getColDef?.()?.field
            if (
              field &&
              params?.node?.data &&
              params.node.data[field] !== undefined
            ) {
              return params.node.data[field]
            }
            return params.value
          },
        })
        break
      case 'EXCEL':
        gridApiRef.current!.api.exportDataAsExcel({
          useValueFormatterForExport: false,
          processCellCallback: (params: any) => {
            const field = params?.column?.getColDef?.()?.field
            if (
              field &&
              params?.node?.data &&
              params.node.data[field] !== undefined
            ) {
              return params.node.data[field]
            }
            return params.value
          },
        })
        break
    }
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton
        size='medium'
        disableRipple
        disableFocusRipple
        onClick={handleClick}
        sx={{ padding: 0 }}
      >
        <MoreVert fontSize='inherit' />
      </IconButton>
      <Menu
        id='demo-customized-menu'
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleClose('EXCEL')} disableRipple>
          Export as Excel
        </MenuItem>
        <MenuItem onClick={() => handleClose('CSV')} disableRipple>
          Export as CSV
        </MenuItem>
      </Menu>
    </>
  )
}
